import { useEffect, useState } from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";

import UserForm from "../components/UserForm";

import Button from "../../../components/common/Button";
import Loader from "../../../components/common/Loader";
import ErrorMessage from "../../../components/common/ErrorMessage";

import { useUsers } from "../hooks/useUsers";



const EditUserPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    fetchUser,
    updateUser,
  } = useUsers();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");
  const [serverError, setServerError] = useState("");

  useEffect(() => {
    let mounted = true;

    const loadUser = async () => {
      try {
        setLoading(true);
        setError("");

        const result = await fetchUser(id);

        if (mounted) {
          setUser(result);
        }
      } catch (error) {
        console.error("Unable to load user:", error);

        if (mounted) {
          setError(
            error?.response?.data?.message ||
              "Unable to load user."
          );
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    if (id) {
      loadUser();
    }

    return () => {
      mounted = false;
    };
  }, [id, fetchUser]);

  const handleSubmit = async (data) => {
    try {
      setSaving(true);
      setServerError("");

      const updated = await updateUser(id, data);

      setUser(updated);

      navigate(`/users/${id}`);
    } catch (error) {
      console.error("Unable to update user:", error);

      setServerError(
        error?.response?.data?.message ||
          "Unable to update user."
      );

      throw error;
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="edit-user-loading">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="edit-user-error">
        <ErrorMessage message={error} />

        <div className="edit-user-back-button">
          <Button
            variant="secondary"
            onClick={() => navigate("/users")}
          >
            Back to users
          </Button>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="edit-user-page">

      {/* Header */}

      <div className="edit-user-header">

        <button
          type="button"
          onClick={() => navigate("/users")}
          className="edit-user-back-link"
        >
          ← Back to users
        </button>

        <h1 className="edit-user-title">
          Edit user
        </h1>

        <p className="edit-user-subtitle">
          Update {user.name}'s account information.
        </p>

      </div>

      {/* Form */}

      <div className="edit-user-card">

        <UserForm
          mode="edit"
          initialData={user}
          onSubmit={handleSubmit}
          onCancel={() =>
            navigate(`/users/${id}`)
          }
          loading={saving}
          serverError={serverError}
        />

      </div>

    </div>
  );
};

export default EditUserPage;